import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { NotFoundComponent } from './not-found/not-found.component';
import { PaymentRequiredGuard } from './payment/guards/payment-required-guard';
import { UserExistsGuard } from './shared/guards/user.guard';

const routes: Routes = [
  {
    path: '',
    canActivate: [UserExistsGuard],
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'courses',
      },
      {
        path: 'courses',
        data: { title: 'Exam Taker Portal | My Course' },
        loadChildren: () => import('./courses/courses.module').then((m) => m.CoursesModule),
        canActivate: [PaymentRequiredGuard],
      },
      {
        path: 'course/:courseId/assessments',
        data: { title: 'Exam Taker Portal | Assessments' },
        loadChildren: () =>
          import('./assessments/assessments.module').then((m) => m.AssessmentsModule),
        canActivate: [PaymentRequiredGuard],
      },
      {
        path: 'payment',
        data: { title: 'Exam Taker Portal | Payment' },
        loadChildren: () => import('./payment/payment.module').then((m) => m.PaymentModule),
      },
    ],
  },
  {
    path: '**',
    data: { title: 'Exam Taker Portal' },
    component: NotFoundComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRouteModule {}
